class BillfoldService {
  constructor ($q, $http, ngAuthSettings) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
  }
  
  getBranchesByThirdId(thirdId) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + '/user/third-center-operating?thirdId=' + thirdId,
        cache : false
      }).then((response) => {
        resolve(response.data);
      }).catch((reason) => {
        reject(reason);
      });
    });
  }
  
  getBillFold(documentNumber, branchCode) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.BILLFOLD.LIST+
          '?terceroDocumentoNumero=' + documentNumber +
          '&codigoSucursal=' + branchCode +
          '&verDetalle=1',
        cache : false
      }).then((response) => {
        resolve(response.data);
      }).catch((reason) => {
        reject(reason);
      });
    });
  }
  
  getBillFolds(documentNumber, codigoSucursal) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.BILLFOLD.LIST + '?terceroDocumentoNumero=' + documentNumber + '&codigoSucursal=' + codigoSucursal,
        cache : false
      }).then((response) => {
        resolve(response.data);
      }).catch((reason) => {
        reject(reason);
      });
    });
  }
  
  getBillFoldsBranches(documentNumber, branchCodes, fecha_ini, fecha_fin) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.BILLFOLD.LIST2,
        data : {
          'documentoTercero' : documentNumber,
          'branchCode' : branchCodes,
          'fecha_ini' : fecha_ini,
          'fecha_fin' : fecha_fin
        },
        cache : false
      }).then((response) => {
        resolve(response.data);
      }).catch((reason) => {
        reject(reason);
      });
    });
  }
}

BillfoldService.$inject = ['$q','$http', 'ngAuthSettings'];

export default BillfoldService;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/reports/billfold/billfold.service.js
 **/